export const fieldNames = ['password', 'confirmPassword']
